export default __webpack_public_path__ + "static/media/img-slider-cmbus-4.9627fa59.png";